import MainComponent from "./MainComponent/MainComponent";
import InitialFormLandingComponent from "./InitialFormLandingComponent/InitialFormLandingComponent";
import FormComponent from "./FormComponent/FormComponent";
import HeaderComponent from "./HeaderComponent/HeaderComponent";
import FooterComponent from "./FooterComponent/FooterComponent";
import SliderComponent from "./SliderComponent/SliderComponent";

const Components = {
	HeaderComponent,
	InitialFormLandingComponent,
	SliderComponent,
	FooterComponent,
	MainComponent,
	FormComponent
};

export default Components;